class PlzFloatingAction extends HTMLElement {
  #observer;

  connectedCallback() {
    this.#observer?.disconnect();
    const inlineAction = this.closest('.plz-product')?.querySelector('[data-plz-inline-action]');
    if (!inlineAction || !('IntersectionObserver' in window)) return;

    const updateVisibility = (visible) => {
      if (visible && this.contains(document.activeElement)) {
        inlineAction.focus({ preventScroll: true });
      }
      this.inert = visible;
      this.setAttribute('aria-hidden', String(visible));
      this.toggleAttribute('data-inline-visible', visible);
    };

    const bounds = inlineAction.getBoundingClientRect();
    updateVisibility(bounds.bottom > 0 && bounds.top < window.innerHeight
      && bounds.right > 0 && bounds.left < window.innerWidth);

    this.#observer = new IntersectionObserver(([entry]) => updateVisibility(entry.isIntersecting));
    this.#observer.observe(inlineAction);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('plz-floating-action')) {
  customElements.define('plz-floating-action', PlzFloatingAction);
}
